import httpClient from './httpClient';

class AuthService {
  login(user) {
    return httpClient.post('auth/signin',{username: user.username,password: user.password})
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('usermenu');
  }
}

export default new AuthService();
